// Copyright (c) 2016 Deere & Company

export const getToggleLabel = collection => collection.length > 0 ?
    'DESELECT_ALL' :
    'SELECT_ALL';

export const forceLanguageSupport = data => {

    const userLanguage = data.settings.language.primaryLanguage;

    const isSupported = userLanguage.allowedPrimaryLanguages.some(lang => lang.key === userLanguage.key);

    const override = isSupported ? userLanguage : {key: 'EN', value: 'English'};

    return {
        ...data,
        settings: {
            ...data.settings,
            language: {
                ...data.settings.language,
                primaryLanguage: {
                    ...data.settings.language.primaryLanguage,
                    ...override
                }
            }
        }
    };

};



// WEBPACK FOOTER //
// ./src/user/shared/services/user-settings-helpers.js